import { useQuery } from '@tanstack/react-query';
import { standardRequest } from 'shared/utils/request';
import { useTalentMatchingTabContext } from 'talent_matching/contexts/talent_matching_tab_context';
import { FilterCoverageResponse } from 'talent_matching/types';

export const useFilterCoverage = (): FilterCoverageResponse | undefined => {
  const { paths } = useTalentMatchingTabContext();
  const path = paths.filterCoveragePath;

  const { data } = useQuery({
    queryKey: ['filterCoverage', path],
    queryFn: async () => {
      const response = await standardRequest.get<FilterCoverageResponse>(
        path as string
      );
      return response.data;
    },
    enabled: Boolean(path),
    staleTime: 1000 * 60 * 10, // 10 minutes
  });

  return data;
};
